import React, {useEffect, useState} from "react";
import EventDisplay from "../Cards/EventCard/EventDisplay";
import Header from "../Cards/CardComponents/Header";
import {ALLOFFERINGS, ALLPUJA,} from "../../rest/endpoints";
import {useAuthHeaders} from "../../utils/getHeaders";
import {apiRequest} from "../../utils/apiRequest";
import {toast} from "react-toastify";
import LoadingIndicator from "./Loading";

const EventToggleListing = () => {
    const headers = useAuthHeaders();
    const [event, setEvent] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [eventType, setEventType] = useState("puja"); // Default to puja


    useEffect(() => {
        const fetchEvents = async () => {
        const url = eventType === "puja" ? ALLPUJA : ALLOFFERINGS;
        try {
            const result = await apiRequest({
            url: `${url}${currentPage - 1}`,
            method: "GET",
            headers,
            });

            const filteredEvents = eventType === "puja"
        ? result?.data?.pujaList?.filter(event => event.eventType === "INPROGRESS_EVENT")
        : result?.data?.offeringList?.filter(event => event.eventType === "INPROGRESS_EVENT");

        setEvent(filteredEvents || []);
        } catch (error) {
            console.error(
            "Error fetching events:",
            error.message || "Something went wrong"
            );
            toast.error("Error fetching events. Please try again.");
        } finally {
            setIsLoading(false);
        }
        };

        fetchEvents();
    }, [eventType]);


    return (
        <div className=" min-h-screen pt-1 -mt-24 md:-mt-24">
        <div className="max-w-full mx-auto px-6 sm:px-16 md:py-20">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <Header eventtype={eventType} />
            <div className="bg-[#FFDBD1] flex justify-evenly gap-3 sm:gap-4 w-[340px] sm:w-[300px] rounded-full shadow-md p-2 sm:p-2">
                <button
                    onClick={() => setEventType("puja")}
                    className={`flex-1 font-medium text-base sm:text-base px-4 sm:px-4 py-2.5 sm:py-2 rounded-full shadow-md transition-colors duration-200 
                    ${
                        eventType === "puja"
                            ? "bg-[#3A1700] text-white"
                            : "bg-transparent border-2 border-[#3A1700] text-[#3A1700] hover:bg-[#3A1700] hover:text-white"
                    }`}
                >
                    Puja
                </button>
                <button
                    onClick={() => setEventType("chadawa")}
                    className={`flex-1 font-medium text-base sm:text-base px-4 sm:px-4 py-2.5 sm:py-2 rounded-full shadow-md transition-colors duration-200 
                    ${
                        eventType === "chadawa"
                            ? "bg-[#3A1700] text-white"
                            : "bg-transparent border-2 border-[#3A1700] text-[#3A1700] hover:bg-[#3A1700] hover:text-white"
                    }`}
                >
                    Chadawa
                </button>
            </div>
            </div>

            {isLoading ? (
            <LoadingIndicator />
            ) : (
            <div>
                <div className="overflow-x-auto whitespace-nowrap sm:-mt-20">
                <EventDisplay
                    events={event}
                    eventtype={eventType}
                    viewType="list"
                />
                </div>
            </div>
            )}

        </div>
        </div>
    );
    };

    export default EventToggleListing; 